<template>
  <div id="blindbox" class="blindbox" :class="theme==0?'dark':'white'">

    <div class="header" v-if="false">
      <img src="/static/img/index/bindBoxBg.png" alt="" class="bindBoxBg">
    </div>

    <div class="tabBox" v-if="false">
      <div :class="{activetab: tab == 1}" @click="changetab(1)">{{$t('blindbox.Noviceguide')}}
      </div><!-- 新手指南 -->
      <div>/</div>
      <div :class="{activetab: tab == 2}" @click="changetab(2)">{{$t('blindbox.commonProblem')}}</div><!-- 常见问题 -->
    </div>
    <div class="mianBox" v-if="false">
      <div class="context_text" v-show="tab == 1">
        <div class="item">
          <div class="text_title">
            <h2> {{$t('blindbox.blindboxDes1')}}</h2>
            <!-- 什么是薄盒？ -->
            <div></div>
          </div>
          <div class="text_cont">
            <div>
              {{$t('blindbox.blindboxDes2')}}
              <!-- 薄盒Mints 为中国首家数字潮玩平台，基于区块链技术确权数字内容，提供可信存证技术、藏品数字凭证技术服务。通过生活中随处可见的智能手机和电子屏，重新定义新的收藏方式。致力于持续提升数字资产的消费和收藏互动体验。 -->
            </div>
            <!-- <div> -->

            <!-- </div> -->
            <!-- <div></div> -->
          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes3')}}</h2>
            <!-- 什么是数字资产？ -->
            <div></div>
          </div>
          <div class="text_cont">
            <div>
              {{$t('blindbox.blindboxDes4')}}
              <!-- 不知从何时开始，许多物件都会因为时间空间而被赋予一个有效期限，就像光盘和影碟会放坏，限量款球鞋会放坏，连价值连城的名画都会因时间而褪色。仿佛已经没有「永恒」的存在，而数字资产的出现却即刻帮我们解决这个问题，数字资产是真正的把时间凝固的收藏，让一切永远可以”专属“于你的藏品。 -->
            </div>

          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes6')}}</h2>
            <!-- 数字资产为什么这么火？ -->
            <div></div>
          </div>
          <div class="text_cont">
            <div>
              {{$t('blindbox.blindboxDes7')}}
              <!-- 数字资产已经成为艺术品一个全新的进化趋势，网络的链接成为对数字资产完成收藏的新工具，虚拟空间成为数字资产收藏的新载体，利用手机、电脑屏幕更为数字收藏构建全新的展示场景。这样的数字资产必将改变传统艺术市场，打破传统的审美范式，让艺术的形式更为多变丰富。成为传统艺术市场的权利结构的破坏者。 -->
            </div>

          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2> {{$t('blindbox.blindboxDes9')}}</h2>
            <div></div>
          </div>
          <div class="text_cont">
            <div>{{$t('blindbox.blindboxDes10')}}</div>


          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes12')}}</h2>
            <!-- 薄盒为什么值得您的信赖？ -->
            <div></div>
          </div>
          <div class="text_cont">
            <div class="text_cont_m">
              {{$t('blindbox.blindboxDes13')}}
              <!-- 薄盒数字资产是基于「区块链」技术协议发行的数字商品。平台为数字资产提供了区块链底层技术支持、可信存证技术、数字商品凭证技术服务。在这里，无论你是创作者还是数字资产的收藏家薄盒都会为您带来更自由的艺术选择。为每一位用户拓展更丰富更酷的玩法。 -->
            </div>
          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes131')}}</h2>

            <div></div>
          </div>
          <div class="text_cont">
            <div class="text_cont_m">
              {{$t('blindbox.blindboxDes132')}}

            </div>
          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes133')}}</h2>

            <div></div>
          </div>
          <div class="text_cont">
            <div class="text_cont_m">
              {{$t('blindbox.blindboxDes134')}}

            </div>
          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes135')}}</h2>

            <div></div>
          </div>
          <div class="text_cont">
            <div class="text_cont_m">
              {{$t('blindbox.blindboxDes136')}}

            </div>
          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes137')}}</h2>

            <div></div>
          </div>
          <div class="text_cont">
            <div class="text_cont_m">
              {{$t('blindbox.blindboxDes138')}}

            </div>
          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes139')}}</h2>

            <div></div>
          </div>
          <div class="text_cont">
            <div class="text_cont_m">
              {{$t('blindbox.blindboxDes140')}}

            </div>
          </div>
        </div>
        <!-- <img src="/static/img/header_box_bg.png" class="header_box_bg">
        <div class="header_box_text">
          <div>{{$t('blindbox.blindboxDes14')}}

          </div>
          <div>{{$t('blindbox.blindboxDes15')}}

          </div>
          <div>{{$t('blindbox.blindboxDes16')}}
          </div>
        </div> -->
      </div>
      <!-- </div>  -->
      <div class="context_text" v-show="tab == 2">
        <div class="item">
          <div class="text_title">
            <h2>1. {{$t('blindbox.blindboxDes17')}}</h2>
            <!-- 什么是数字资产？ -->
            <div></div>
          </div>
          <div class="text_cont">
            <div>
              A、{{$t('blindbox.blindboxDes18')}}
              <!-- 数字资产可以包罗万象，无论是视频、图像、模型还是游戏、门票、球星卡，任何的数字商品一旦上链之后，就拥有了唯一且永远在链的身份证“数字证书“。每一件艺术品都是只属于你的存在，它是不可篡改、不可分割、不可复制、独一无二的！就像是雪花，每一片都是唯一的存在，这就是数字资产。 -->
            </div>
            <div>B、{{$t('blindbox.blindboxDes19')}}</div>
            <div>C、{{$t('blindbox.blindboxDes20')}}</div>
            <div>D、{{$t('blindbox.blindboxDes21')}}</div>
            <div><b>{{$t('blindbox.blindboxDes22')}}</b></div>
          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes23')}}</h2>
            <div></div>
          </div>
          <div class="text_cont">
            <div>
              {{$t('blindbox.blindboxDes24')}}

            </div>
          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2> {{$t('blindbox.blindboxDes25')}}</h2>

            <div></div>
          </div>
          <div class="text_cont">
            <div>{{$t('blindbox.blindboxDes26')}}
              <img src="/static/img/index/bilndIcon2.png" alt="" class="bilndIcon">
              {{$t('blindbox.blindboxDes27')}}
              <img src="/static/img/index/bilndIcon3.png" alt="" class="bilndIcon">
              {{$t('blindbox.blindboxDes28')}}
              <img src="/static/img/index/blindIcon1.png" alt="" class="bilndIcon">
              {{$t('blindbox.blindboxDes29')}}
            </div>
          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes30')}}</h2>
            <div></div>
          </div>
          <div class="text_cont">
            <div>{{$t('blindbox.blindboxDes31')}}</div>

          </div>
        </div>
        <!-- <div class="item">
          <div class="text_title">
            <h2>5. 除了开盲盒，如何获得更多喜欢的数字资产？</h2>
            <div></div>
          </div>
          <div class="text_cont">
            <div>除了开盲盒的形式，用户可以通过交易市场或者他人赠送的方式获得数字资产。不是每一个数字资产均支持上架交易市场或者赠送，在商品的说明中会有注明，购买前请注意查看介绍。</div>
          </div>
        </div> -->
        <!-- <div class="item">
          <div class="text_title">
            <h2>6. 什么是交易市场？</h2>
            <div></div>
          </div>
          <div class="text_cont">
            <div>A.如何购买喜欢的数字资产<br />
              官网首页点击“交易市场”输入您想要的艺术品名称进行搜索，也可以按照价格、编号...等维度筛选。选择自己喜欢的数字资产进入详情，点击“立即购买”挑选编号购买。</div>
            <div>B.如何销售多余的数字资产<br />
              官网首页点击右上角进入个人中心-“已收藏”，选择您要售卖的数字资产，进入详情后，点击“出售”，输入出售价格即可。为了保障市场秩序，如您销售的商品价格超过市场预期价格，则需要您这边完成实名认证后才可上架。
              数字资产出售之前，您可以在出售页面“查询市场价格”，查看其他用户挂单价格作为参考，一般序号越小价值会越大， 或者与数字资产、创作家有关联行序号价值也很大。</div>
          </div>
        </div> -->
        <!-- <div class="item">
          <div class="text_title">
            <h2>7. 交易市场的交易规则</h2>
            <div></div>
          </div>
          <div class="text_cont">
            <div>交易市场上数字一说的每次交易，均收取5%的交易费。例如当一个价格为¥100.00的数字资产被出售，卖方账户余额将获得¥95。在交易市场上架数字资产，不收取任何费用。</div>
            <div>针对盲盒和数字资产的交易过程会记录在区块链上，所以不支持退款。此外，提现功能尚未开放，敬请期待。</div>
            <div>交易市场的数字资产目前仅支持人民币购买，且只允许中国用户购买。</div>
          </div>
        </div> -->
        <div class="item">
          <div class="text_title">
            <h2> {{$t('blindbox.blindboxDes32')}}</h2>
            <!-- 如何管理自己的个人中心 -->
            <div></div>
          </div>
          <div class="text_cont">
            <div>{{$t('blindbox.blindboxDes33')}}</div>

          </div>
        </div>
        <div class="item">
          <div class="text_title">
            <h2>{{$t('blindbox.blindboxDes35')}}</h2>
            <!-- 积分是什么？ -->
            <div></div>
          </div>
          <div class="text_cont">
            <div>{{$t('blindbox.blindboxDes36')}}</div>
            <!-- 在平台购买盲盒或者参与活动都会获得相应的积分。积分可以解锁后续特殊盲盒的购买，还有更多积分的玩法后续会陆续在平台上线。具体获得积分规则可在“薄盒”服务号回复积分获得。 -->
          </div>
        </div>

      </div>
      <img src="/static/img/header_footer_img.png" class="header_footer_img" alt="">
    </div>
  </div>
</template>

<script>
  export default {

    data() {
      return {
        tab: 1,
        theme: 0,
      }
    },
    methods: {
      changetab(item) {
        this.tab = item;
      }
    },
    mounted() {
      if (this.$route.query.type == "problem") {
        this.tab = 2
      }
      window.scrollTo({
        top: 200,
        behavior: "smooth"
      });
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
        console.log(this.theme)
      }
    },
  }

</script>

<style lang="less" scoped>
  .dark {
    background: #000000;



  }



  .blindbox {
    position: relative;

    .header {
      height: 246px;
      width: 100%;
      position: relative;


      .bindBoxBg {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .tabBox {
      margin-top: 14.5px;
      margin: 25px 16px 0;
      display: flex;
      flex-direction: row;
      padding-bottom: 10px;
      align-items: center;

      div {
        color: #FFFFFF;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        padding-right: 11px;
      }

      .activetab {
        font-size: 19px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }

    .context_text {
      padding: 0 16px 36px;

      .bilndIcon {
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin: 0 5px;
      }

      .text_title {
        h2 {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 25px;
        }

        div {
          background: url('/static/img/header_border.png');
          background-size: 100% 100%;
          width: 15px;
          height: 2px;
          margin-top: 15px;
          margin-bottom: 15px;
        }
      }

      .text_cont {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8D8F9F;
        line-height: 25px;

        div {
          margin-bottom: 35px;
        }

        .text_cont_m {
          margin-bottom: 0;
        }
      }

      // 137 115
      .header_box_bg {
        width: 65.5px;
        height: 57.5px;
        margin-left: -20px;
      }

      .header_box_text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8D8F9F;
        line-height: 25px;
        margin-bottom: 50px;
      }
    }

    .header_footer {
      // 405 194

    }

    .header_footer_img {
      position: absolute;
      z-index: 2;
      width: 202.5px;
      height: 87px;
      right: 0px;
      bottom: 0;
    }
  }

  .white {
    background: #ffffff;



    .tabBox {

      div {
        color: #333333;
      }

      .activetab {
        color: #333333;
      }
    }

    .context_text {
      .text_title {
        h2 {
          color: #333333;
        }
      }

      .text_cont {
        color: #333333;
      }

      .header_box_text {
        color: #333333;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/blindbox.vue